"use client"
// import React from "react";
import AppleSignin from "react-apple-signin-auth";
import axios from "axios";
import AppleIcon from "@/icons/appleIcon";
import {redirect} from "@/navigation";
import {BASE_URL} from "@/constants";
import {createSession} from "@/app/[locale]/auth/session";
// import { signIn } from "next-auth/react";

const MyAppleSigninButton = () => (
  <AppleSignin
    /** Auth options passed to AppleID.auth.init() */
    authOptions={{
      /** Client ID - eg: 'com.example.com' */
      clientId: "com.esimafly.app-service",
      /** Requested scopes, seperated by spaces - eg: 'email name' */
      scope: "email name",
      /** AppleSingIn's redirectURI - must be one of the URIs you added to the serviceID - the undocumented trick in apple docs is that you should call auth from a page that is listed as a redirectURI, localhost fails */
      redirectURI: "https://www.esimafly.com",
      usePopup: true,
      // state:'test'
      /** State string that is returned with the apple response */
      // usePopup: true,
      /** Uses popup auth instead of redirection */
    }} // REQUIRED
    /** General props */
    uiType="dark"

    /** className */
    className="apple-auth-btn"
    /** Removes default style tag */
    noDefaultStyle={false}
    /** Allows to change the button's children, eg: for changing the button text */
    buttonExtraChildren="Continue with Apple"
    /** Called upon signin success in case authOptions.usePopup = true -- which means auth is handled client side */
    onSuccess={async (response) => {
      try {
        const body = {
          code: response?.authorization?.code,
          id_token: response?.authorization?.id_token,
          email: response?.user?.email,
          firstName: response?.user?.name?.firstName,
          lastName: response?.user?.name?.lastName,
        };
        // await axios.post("api/auth/apple", body);
        const resp = await axios.post(BASE_URL + "user-auth/apple",{
          ...body
        });
        const data = resp.data;
        await createSession(data);

        window.location.href = `/`;
        // redirect('/')
      } catch (error) {
        console.error("Error:", error);
      }
    }} // default = undefined
    /** Called upon signin error */
    onError={(error) => console.error(error)} // default = undefined
    /** render function - called with all props - can be used to fully customize the UI by rendering your own component  */
    render={(props) => (
      <button
        className=" flex shrink-0 cursor-pointer items-center justify-center rounded-lg bg-black p-3 pt-2 shadow-lg"
        style={{width:'42px', height: '40px'}}
        {...props}
      >
        <AppleIcon />
      </button>
    )}
  />
);
export default MyAppleSigninButton;
